module.exports = __webpack_public_path__ + "img/craftBannerBrokerMobile.a320828.jpg";